<template>
    <div>
        <section class="accordions">
            <article class="accordion" :class="{'is-active': newPin.newPinVisible}">
                <div
                    class="accordion-header toggle is-size-5"
                    @click="newPin.newPinVisible = !newPin.newPinVisible"
                >
                    <a>Create pin for player ⯆</a>
                </div>
                <div class="accordion-body">
                    <div class="accordion-content has-background-dark has-text-white">
                        <div class="field">
                            <label class="label">Currency</label>
                            <div class="control">
                                <div class="select">
                                    <select v-model="newPin.currency">
                                        <option
                                            v-for="currency in currencies"
                                            :key="currency.id"
                                        >{{currency.id}}</option>
                                    </select>
                                </div>
                            </div>
                            <p
                                class="help is-danger"
                                v-if="!$v.newPin.currency.required"
                            >Currency is required</p>
                        </div>
                        <div class="field">
                            <label class="label">Pin value</label>
                            <div class="control">
                                <currency-input
                                    v-if="newPin.currency"
                                    :value="newPin.value"
                                    :currency="newPin.currency"
                                    :set="(val) => newPin.value = val"
                                    class="input oc-input"
                                />
                            </div>
                            <p
                                class="help is-danger"
                                v-if="!$v.newPin.value.required"
                            >Enter pin value</p>
                            <p
                                class="help is-danger"
                                v-if="!$v.newPin.value.minValue"
                            >Min pin value is 0.01</p>
                        </div>
                        <div class="field">
                            <label class="label"></label>
                            <div class="control">
                                <label class="checkbox">
                                    <input type="checkbox" v-model="newPin.isDemo" />
                                    Demo pin
                                </label>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Branch</label>
                            <div class="control">
                                <input class="input oc-input" type="text" v-model="newPin.branch" />
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Description</label>
                            <div class="control">
                                <input
                                    class="input oc-input"
                                    type="text"
                                    v-model="newPin.description"
                                />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <button
                                    class="button is-success"
                                    @click="create()"
                                    :disabled="$v.$invalid"
                                >Create pin</button>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <pin-list ref="pinList" :data-func="loadPins" />
    </div>
</template>

<script>
import pinList from '../../../../common/pin-list.vue';

import state from '../../../../../state';
import pinService from '../../../../../services/pin.service';
import currencyService from '../../../../../services/currency.service';

import { required, minValue } from 'vuelidate/lib/validators';
import currencyInput from "../../../../common/currency-input.vue";

export default {
    name: 'player-pins',
    components: { pinList, currencyInput },
    data() {
        return {
            newPin: {
                value: 0,
                currency: null,
                branch: null,
                description: null,
                newPinVisible: false
            }
        };
    },
    computed: {
        playerId() {
            return this.$route.params.playerId;
        },
        player() {
            return state.editPlayer.get();
        },
        currencies() {
            return state.currencies.get();
        }
    },
    validations: {
        newPin: {
            value: {
                required,
                minValue: minValue(0.01)
            },
            currency: {
                required
            }
        }
    },
    async mounted() {
        await this.$refs.pinList.load();
    },
    methods: {
        async loadPins(filter) {
            return await pinService.getByPlayer(this.playerId, filter);
        },
        async create() {
            await pinService.create(
                this.playerId,
                this.newPin.value,
                this.newPin.currency,
                this.newPin.branch,
                this.newPin.description,
                this.newPin.isDemo
            );
            await this.$refs.pinList.load();
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/pins.vue